import { useQuery } from '@tanstack/react-query';
import { getOfferingCategoryOptions } from '../../lib/api/options';
import type { GetOfferingCategoryOptionsParams } from '../../lib/api/options';

export function useOfferingCategoryOptions(
  params: GetOfferingCategoryOptionsParams = {},
  enabled = true,
) {
  return useQuery({
    queryKey: ['options', 'offering-categories', JSON.stringify(params)],
    queryFn: () => getOfferingCategoryOptions(params),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
